// extracted by mini-css-extract-plugin
export default {"addServBox":"FormSpecialties_addServBox__7Tp4d","addBox":"FormSpecialties_addBox__GoemU","consigner":"FormSpecialties_consigner__F6nSS","seller":"FormSpecialties_seller__unYLX"};